export default __webpack_public_path__ + "static/mid6b-3804b89e4d0bbb6209f33f28d4aeeb40.png";